import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { LocalStorageService } from "angular-2-local-storage";

import { environment } from "../../../environments/environment";
import { AuthorizedApps } from "../../enum/shared/authorized-apps.enum";
import { UserData } from "../../model/authentication/user.data";
import { PolicyModel } from "../../model/shared/policy.model";
import { AuthenticationService } from "../../service/api/auth/auth.service";
import { BuilkAuthService } from "../../service/api/builk/builk-auth.service";
import { IntakeAuthService } from "../../service/api/intake/intake-auth.service";
import { PolicyService } from "../../service/policy.service";

@Component({
    selector: "bo-home",
    templateUrl: "./home.component.html",
    styleUrls: ["./home.component.scss"]
})

export class HomeComponent implements OnInit {

    constructor(
        private readonly AuthService: AuthenticationService,
        private readonly builkAuthService: BuilkAuthService,
        private readonly localStorageService: LocalStorageService,
        private readonly router: Router,
        private readonly policyService: PolicyService,
        private readonly intakeAuthService: IntakeAuthService
    ) { }

    user_data: UserData = new UserData();
    userEmail: string = "";
    policies: Array<PolicyModel>;
    userPolicy: PolicyModel;

    canAccessJubili = false;
    canAccessBuilk = false;
    canAccessIntake = false;
    isNavigating = false;

    ngOnInit(): void {
        this.userEmail = this.localStorageService.get<string>("userEmail");

        this.policyService.getUserPolicy(environment.firebaseConfig.policyCollection,
            "userEmail",
            this.localStorageService.get<string>("userEmail"))
            .subscribe(response => {
                console.log(response)
                this.canAccessJubili = response[0].authorizedApps
                    .find(f => f.appName === AuthorizedApps.Jubili) === undefined ? false : true;
                this.canAccessBuilk = response[0].authorizedApps
                    .find(f => f.appName === AuthorizedApps.Builk) === undefined ? false : true;
                this.canAccessIntake = response[0].authorizedApps
                    .find(f => f.appName === AuthorizedApps.Intake) === undefined ? false : true;
            });
    }

    getUserDataIntake(): void {
        const accessToken = this.localStorageService.get<string>("accessToken");
        this.intakeAuthService.authenticate(this.userEmail, accessToken)
            .subscribe(
                response => {
                    this.localStorageService.set("intakesToken", response.credentialKey);
                    this.router.navigate(["/intake/organization-list"]);
                }, err => {
                    console.error("Intake authentication failed", err);
                    if (err.status === 401) {
                        this.AuthService.refreshSessionToken()
                            .subscribe(
                                Response => {
                                    this.localStorageService.set("accessToken", Response.authenticationResult.accessToken);
                                    this.localStorageService.set("expiresTime", (Date.now() / 1000) + Response.authenticationResult.expiresIn);
                                    this.getUserDataIntake();
                                }
                            );
                    }
                }
            );
    }

    getUserDataJubili(): void {

        this.AuthService.getUserData(this.userEmail)
            .subscribe(
                response => {
                    this.user_data = response;
                    // Storage Session
                    this.localStorageService.set("userName", this.user_data.userFullName);
                    this.localStorageService.set("userSurrKey", this.user_data.userSurrKey);

                    // this.router.navigate(["/jubili"]);
                    this.router.navigate(["/jubili/company"]);
                }, err => {
                    console.log("unauth");
                    console.log(err.message)
                    if (err.status === 401) {
                        this.AuthService.refreshSessionToken()
                            .subscribe(
                                Response => {
                                    // Update session
                                    this.localStorageService.set("accessToken", Response.authenticationResult.accessToken);
                                    this.localStorageService.set("expiresTime", (Date.now() / 1000) + Response.authenticationResult.expiresIn);

                                    // re-function
                                    this.getUserDataJubili();
                                }
                            );
                    } else {
                        // this.router.navigate(["/home"]);
                    }
                }
            );
    }

    getUserDataBuilk(): void {
        this.isNavigating = true;
        this.builkAuthService.getUserData()
            .subscribe(
                response => {
                    this.user_data = response;
                    // Storage Session
                    this.localStorageService.set("userName", this.user_data.userFullName);
                    this.localStorageService.set("userSurrKey", this.user_data.userSurrKey);

                    this.router.navigate(["/builk"]);
                    this.isNavigating = false;
                }, err => {
                    console.log("unauth");
                    console.log(err.message)
                    if (err.status === 401) {
                        this.AuthService.refreshSessionToken()
                            .subscribe(
                                Response => {
                                    // Update session
                                    this.localStorageService.set("accessToken", Response.authenticationResult.accessToken);

                                    this.localStorageService.set("expiresTime", (Date.now() / 1000) + Response.authenticationResult.expiresIn);
                                }
                            );
                        this.getUserDataJubili();
                    } else {
                        // this.router.navigate(["/home"]);
                    }
                    this.isNavigating = false;
                }
            );
    }

    redirectToDS(): void {
        this.router.navigate(["/designsystem"]);
    }
}
